module.exports = __webpack_public_path__ + "img/take-care.072f4262.png";